import axios from 'axios';
import {Notification, MessageBox, Message} from 'element-ui';
import store from '@/store';
import {getToken} from '@/utils/auth';
// const qs = require ('qs');
// const paramsFormat = function (params) {
//   let resParams = {};
//   for (let i in params) {
//     let val = params[i];
//     if (Array.isArray (val) && val.length > 0) {
//       resParams[i] = val;
//     } else if (val && typeof val === 'object' && JSON.stringify (val) != '{}') {
//       resParams[i] = val;
//     } else if (val || val === 0) {
//       resParams[i] = val;
//     }
//   }
//   return resParams;
// };
const service = axios.create ({
  baseURL: process.env.VUE_APP_STAKE_API,
  timeout: 120000,
});
service.interceptors.request.use (
  config => {
    if (getToken ()) {
      config.headers['Authorization'] = 'Bearer ' + getToken ();
    }
    
    if (config.vconfig && config.vconfig.noBaseApi) {
      config.baseURL = process.env.VUE_APP_STAKE_USER_API;
    }
    return config;
  },
  error => {
    console.log (error);
    Promise.reject (error);
  }
);

service.interceptors.response.use (
  res => {
    if (res.status === 200) {
      return res.data;
    } else {
      Notification.error ({
        title: 'No data',
      });
      return Promise.reject ([]);
    }
  },
  error => {
    // Message ({
    //   message: error,
    //   type: 'error',
    //   duration: 5 * 1000,
    // });
    return Promise.reject (error);
  }
);

export default service;
